import axios from 'axios'
import url from '@/url'
import Storage from '@/helpers/storage.js'

export const state = {
    markets: Storage.get('markets') || []
}

export const actions = {
    createEntityAdmin({commit},data) {
        return new Promise( (resolve, reject) => {
            axios.post(`${url()}/admin/create`,data)
            .then(response => {
                resolve(response)
            }).catch(err => {
                reject(err)
            })
        })
    },
    addMarket({commit},market) {
        return new Promise( (resolve, reject) =>{
            axios.post(`${url()}/market/`,market, {headers: {
                'Authorization': `Bearer ${Storage.get('token')}`
            }})
                .then(response => {
                    commit('add_market',response.data)
                    console.log('response', response.data)
                    resolve(respone)
                }).catch(err => reject(err))
        })
    },
    getAllMarkets({commit}) {
        return new Promise((resolve,reject) => {
            axios.get(`${url()}/market/`)
                .then(response =>{
                    commit('add_markets',response.data)
                    console.log('response', response.data)
                    resolve(response)
                }).catch(err => {
                    reject(err)
                })
        }) 
    },
    updateMarket({commit},id,market){
        return new Promise( (resolve, reject) => {
            axios.put(`${url()}/market/${id}`,market)
                .then(response => {
                    resolve(response)
                }).catch(err => reject(err))
        })
    },
    deleteMarket({commit},id,market){
        return new Promise( (resolve, reject) => {
            axios.put(`${url()}/market/${id}`,market)
                .then(response => {
                    resolve(response)
                }).catch(err => reject(err))
        })
    },
}
export const mutations = {
    add_markets(state, data) {
        state.markets = data
        Storage.set('markets')
    }
}
export const getters = {
    markets: state => state.markets
}